import React from "react";
import SearchIcon from "assets/icons/Search.svg";
const SearchBar = ({ label = "", placeholder = "", select = [], onSearch }) => {
  return (
    <div className="flex gap-1 md:gap-4  flex-nowrap sm:flex-wrap  justify-between">
      <div className="flex-1 min-w-[200px] md:min-w-[300px] max-w-[500px] w-full">
        <label className="text-[12px] font-bold text-[#333333] mb-1 block">
          {label}
        </label>
        <div className="relative w-full">
          <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
            <img src={SearchIcon}></img>
          </span>
          <input
            placeholder={placeholder}
            className="text-[#242424] bg-[#F8F8F8] w-full rounded-xl px-10 py-3 text-start min-w-[200] md:min-w-[300px] max-w-[500px]"
            style={{ paddingLeft: "2.2rem" }}
            onChange={(e) => onSearch && onSearch(e.target.value)}
          />
        </div>
      </div>
      {/* <div className="space-x-4 flex flex-wrap self-end space-y-2 md:space-y-4 gap-2 md:gap-4 md:flex-shrink-0 mt-0 sm:mt-4 w-full sm:w-auto">
        {select.map((item, idx) => (
          <select
            style={{ margin: "0px" }}
            key={idx}
            className="text-[#767676] bg-[#F8F8F8]  max-h-[36px] w-[214px] rounded-xl p-3 py-[8px] text-start "
          >
            <option>{item.label}</option>
            {item.values.map((value, vIdx) => (
              <option key={vIdx} value={value}>
                {value}
              </option>
            ))}
          </select>
        ))}
      </div> */}
    </div>
  );
};
export default SearchBar;
